//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service'
export default {
    data () {
        return {
            users: []
        }
    },
    methods: {
        getData (house_id) {
            Service.getUserNums(house_id)
                .then(({ items}) => this.users = items)
        },
        addNum () {
            const { name } = this
            const { building_id } = this.$route.query
            wx.navigateTo({
                url: `/building/add_num/main?building_id=${building_id || ''}&house_id=${this.house_id || ''}&name=${name}`
            })
        },
        search (e) {
            const { regnum, lnnum } = e.currentTarget.dataset
            const { building_id } = this.$route.query
            const url = `/building/lot_detail/main?regNum=${regnum}&building_id=${building_id || ''}&house_id=${this.house_id || ''}&lnNum=${lnnum}`
            wx.navigateTo({
                url
            })
        }
    },
    props: {
        building_id: {
            type: Number,
        },
        house_id: {
            type: Number,
        },
        name: {
            type: String
        },
        show: {
            type: Boolean
        }
    }
}
